module.exports = __webpack_public_path__ + "static/media/login.03e11b67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/assets/illustrations/login.svg
// module id = 1602
// module chunks = 0